module.exports = __webpack_public_path__ + "media/images/thumbnails/ad-missing-8f6ecec4d226977ad1f04fc7cbc4a5e4.jpg";